"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const lodash_mergewith_1 = __importDefault(require("lodash.mergewith"));
const tab_1 = __importDefault(require("./tab"));
function default_1(options) {
    const tab = new tab_1.default(window);
    let key = 'vuex-multi-tab';
    let statesPaths = [];
    if (options) {
        key = options.key ? options.key : key;
        statesPaths = options.statesPaths ? options.statesPaths : statesPaths;
    }
    function filterStates(paths, state) {
        let result = {};
        paths.forEach(path => {
            const subPaths = path.split('.');
            let object = {};
            const branch = object;
            const value = subPaths.reduce((current, subPath) => {
                return current[subPath];
            }, state);
            for (let i = 0; i < subPaths.length - 1; i += 1) {
                object[subPaths[i]] = {};
                object = object[subPaths[i]];
            }
            object[subPaths[subPaths.length - 1]] = value;
            result = lodash_merge_1.default(result, branch);
        });
        return result;
    }
    // eslint-disable-next-line consistent-return
    function mergeCustomizer(objValue, srcValue) {
        // If merging array, return the new array
        if (Array.isArray(objValue)) {
            return srcValue;
        }
    }
    function mergeState(oldState, newState) {
        return lodash_mergewith_1.default({}, oldState, newState, mergeCustomizer);
    }
    if (!tab.storageAvailable()) {
        throw new Error('Local storage is not available!');
    }
    return (store) => {
        // First time, fetch state from local storage
        tab.fetchState(key, (state) => {
            store.replaceState(mergeState(store.state, state));
        });
        // Add event listener to the state saved in local storage
        tab.addEventListener(key, (state) => {
            store.replaceState(mergeState(store.state, state));
        });
        store.subscribe((mutation, state) => {
            let toSave = state;
            // Filter state
            if (statesPaths.length > 0) {
                toSave = filterStates(statesPaths, state);
            }
            // Save state in local storage
            tab.saveState(key, toSave);
        });
    };
}
exports.default = default_1;
